import { render, staticRenderFns } from "./BaseButtonIcon.vue?vue&type=template&id=42f398f1&scoped=true&"
import script from "./BaseButtonIcon.vue?vue&type=script&lang=js&"
export * from "./BaseButtonIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonIcon.vue?vue&type=style&index=0&id=42f398f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f398f1",
  null
  
)

export default component.exports